import React from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'react-router-redux';

// Actions
import { openSheet } from '../../../structural/sheet/sheetActions';
import { intercomShowMessages } from '../../../../analytics/analyticsActions';

// Components
import Icon from '../../../../components/icons/Icon';
import Button from '../../../../components/buttons/Button';
import MobileNotificationsUtil from './MobileNotificationsUtil';
import MobileSearchTool from '../../tools/searchTool/MobileSearchTool';

// Types
import { SheetId } from '../../../structural/sheet/sheetTypes';

import './MobileUtilsToolList.scss';

const MobileUtilsToolList = () => {
    const dispatch = useDispatch();

    const dispatchOpenMobileNotificationsSheet = () => dispatch(openSheet(SheetId.Notifications));

    return (
        <div className="MobileUtilsToolList">
            <Button className="mobile-util-button" onClick={() => dispatch(intercomShowMessages())}>
                <Icon name="mobile-toolbar-support" />
                <div className="label">Support</div>
            </Button>
            <MobileSearchTool />
            <Button className="mobile-util-button" onClick={dispatchOpenMobileNotificationsSheet}>
                <MobileNotificationsUtil />
            </Button>
            <Button className="mobile-util-button" onClick={() => dispatch(push('/account'))}>
                <Icon name="mobile-toolbar-settings" />
                <div className="label">Settings</div>
            </Button>
        </div>
    );
};

export default MobileUtilsToolList;
